export const EXPERIMENT_ID = 'tm-8273-room-gallery-sections-v2';

const VERSION_SECTIONS = 1;

const SECTIONS_VARIANT = '[data-gallery-variant="sections"]';
const FLAT_VARIANT = '[data-gallery-variant="flat"]';

let version = null;
let impressionSent = false;

const dropVariant = (root, selector) => {
  root.querySelectorAll(selector).forEach((el) => el.remove());
};

/**
 * Keeps only the gallery the visitor is meant to see. Both are server-rendered because room pages
 * are edge-cached - one HTML response reaches everyone, so the split can only happen in the browser.
 * Runs on the <template> before it is cloned, so the losing gallery never enters the page.
 *
 * Rooms whose photos all land in one section render a single gallery and stay out of the experiment,
 * since both versions would look the same to them.
 *
 * @todo TM-8273 keep the winning gallery and drop the other one once the experiment is settled
 * @returns {?number} the allocated version, or null for visitors outside the experiment
 */
export const applyGallerySectionsExperiment = (galleryEl, mosaicTemplate) => {
  const content = mosaicTemplate?.content;
  if (!content?.querySelector(SECTIONS_VARIANT)) {
    return null;
  }

  version = window.getVersionFromCookieId?.(EXPERIMENT_ID) ?? null;

  if (version !== VERSION_SECTIONS) {
    dropVariant(content, SECTIONS_VARIANT);

    return version;
  }

  dropVariant(content, FLAT_VARIANT);

  if (galleryEl?.dataset.galleryItemsSections) {
    galleryEl.dataset.galleryItems = galleryEl.dataset.galleryItemsSections;
  }

  return version;
};

/**
 * Sent when the gallery opens, because that is the first moment the two versions differ - visitors
 * who never open it would only add noise to the results.
 */
export const trackGallerySectionsImpression = () => {
  if (impressionSent || version === null) {
    return;
  }

  impressionSent = true;

  App.track.event('experiment_impression', {
    experiment_id: EXPERIMENT_ID,
    variant_id: version,
  });
};
